module.exports = __webpack_public_path__ + "static/media/S4EC.3b91ee6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/S4EC.jpg
// module id = 93
// module chunks = 0